/* eslint-disable jsx-a11y/alt-text */
import { Hooks } from 'providers';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Btn from '_revamp/atoms/button';

import ImgFailed from 'assets/img/failed_img.png';
import ImgSuccess from 'assets/img/success_img.png';

import { HIT_BOARD_STATUSV2 } from '_revamp/redux/action/admin/board';

function PopUp() {
  const dispatch = useDispatch();
  const {
    statusV2, messageV2, listViewV2, title,
  } = useSelector((state) => ({
    statusV2: state.board.statusV2,
    messageV2: state.board.messageV2,
    listViewV2: state.board.listViewV2,
    title: state.board.title,
  }));
  const { setModal, modal } = useContext(Hooks);
  const [switch_, setSwitch] = useState(false);
  useEffect(() => {
    if (statusV2 === 'success' || statusV2 === 'failed') {
      setModal(true);
      setSwitch(true);
    }
  }, [statusV2]);

  return (
    <div
      className={`modal fade rModal layoutCustom ${
        (statusV2 === 'success' || statusV2 === 'failed') && 'show'
      }`}
      id="successModal_regis"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content" style={{ borderRadius: '20px' }}>
          <div className="modal-body m-3">
            <img
              src={statusV2 === 'success' ? ImgSuccess : ImgFailed}
              className="rModalImg mt-4"
            />
            {listViewV2 === 'listViewV2' ? (
              <ul className="mb-0 sizePopUp">
                {title.split(', ').map((val, index) => (
                  <li key={index}>
                    {' '}
                    {val}
                    {' '}
                  </li>
                ))}
              </ul>
            ) : (
              // <p className="mb-0 msg">{deskripsi}</p>
              <div className="textDark mt-5 overflowHidden maxHeight200px">
                <p
                  className="fW600 sansSerif mb-4"
                  style={{ fontSize: '14px' }}
                >
                  {title}
                </p>
                <p
                  className={` ${
                    messageV2 !== undefined ? '' : 'd-none'
                  } maxWidth200px mx-auto sansSerif lH18px`}
                  style={{ fontSize: '14px' }}
                >
                  {messageV2}
                </p>
              </div>
            )}
            <div className="maxWidth200px mx-auto mt-4">
              <Btn
                style={{
                  backgroundColor: '#3D5AFE',
                  height: '30px',
                  fontSize: '12px',
                }}
                func={() => {
                  setModal(false);
                  dispatch({
                    type: HIT_BOARD_STATUSV2,
                    payload: {
                      status: '',
                      message: '',
                      listView: '',
                      title: '',
                    },
                  });
                }}
              >
                Tutup
              </Btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopUp;
